<div class="die" [ngClass]="[currentDiceClass]">  <span class="dot"></span></div>
<hr />
<button [disabled]="rolling" class="btn btn-primary" (click)="rollDice()">Roll the dice</button>
@if (showFireworks) {
  <ep-egg-fireworks></ep-egg-fireworks>
}

<!--<div class="die one">  <span class="dot"></span></div>
<div class="die two">  <span class="dot"></span></div>
<div class="die three"><span class="dot"></span></div>
<div class="die four"> <span class="dot"></span></div>
<div class="die five"> <span class="dot"></span></div>
<div class="die six">  <span class="dot"></span></div>-->